/*
 * 订单确认
 * */
import request from "@utils/request";

/**
 * 通过购物车 id 获取订单信息
 * @param cartId
 * @returns {*}
 */
export function postOrderConfirm(cartId) {
  return request.post("/order/confirm", { cartId });
}

/**
 * 计算订单金额
 * @param key
 * @param data
 * @returns {*}
 */
export function postOrderComputed(key, data) {
  return request.post("/order/computed/" + key, data);
}

/**
 * 获取指定金额可用优惠券
 * @param price
 * @returns {*}
 */
export function getOrderCoupon(price, data) {
  return request.get("/coupons/order/" + (parseFloat(price) || 0), data);
}

/**
 * 生成订单
 * @param key
 * @param data
 * @returns {*}
 */
export function createOrder(key, data) {
  return request.post("/order/create/" + key, data || {});
}

/**
 * 订单统计数据
 * @returns {*}
 */
export function getOrderData() {
  return request.get("/order/data");
}

/**
 * 订单列表
 * @returns {*}
 */
export function getOrderList(data) {
  return request.get("/order/list", data);
}

/**
 * 取消订单
 * @returns {*}
 */
export function cancelOrder(id) {
  return request.post("/order/cancel", { id });
}

/**
 * 订单详情
 * @returns {*}
 */
export function orderDetail(id) {
  return request.get("/order/detail/" + id);
}
/**
 * 代理订单详情
 * @param string uni 
*/
export function getConditionDetail(uni){
  return request.get('conditiondetail/' + uni);
}

/**
 * 10.21 续费代理订单详情
 * @param string uni 
*/
export function getStatusRenewal(uni){
  return request.get('conditiondetail/renew/' + uni);
}


/**
 * 退款理由
 * @returns {*}
 */
export function getRefundReason() {
  return request.get("/order/refund/reason");
}

/**
 * 售后理由
 * @returns {*}
 */
 export function getRefundServiceReason() {
  return request.get("/order/refund/servicereason");
}

/**
 * 提交退款
 * @returns {*}
 */
export function postOrderRefund(data) {
  return request.post("/order/refund/verify", data);
}

/**
 * 确认收货
 * @returns {*}
 */
export function takeOrder(uni) {
  return request.post("/order/take", { uni });
}

/**
 * 删除订单
 * @returns {*}
 */
export function delOrder(uni) {
  return request.post("/order/del", { uni });
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function express(uni) {
  return request.get("order/express/" + uni);
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function payOrder(uni, paytype, from) {
  return request.post("order/pay", { uni, paytype, from });
}
/**
 * 预售订单支付
 * @returns {*}
 */
export function payOrderPresell(uni, paytype, from) {
  return request.post("presell/pay", { uni, paytype, from });
}
/**
 * 订单核销
 * @returns {*}
 */
export function orderVerific(verify_code, is_confirm) {
  return request.post("order/order_verific", { verify_code, is_confirm });
}
/**
 * 再次下单
 * @param string uni
 *
 */
export function orderAgain(uni) {
  return request.post("order/again", { uni: uni });
}
// 积分商城
export function postIntegralOrderConfirm(cartId) {
  return request.post("/integralorder/confirm", { cartId });
}

export function postIntegralOrderComputed(key, data) {
  return request.post("/integralorder/computed/" + key, data);
}

export function createIntegralOrder(key, data) {
  return request.post("/integralorder/create/" + key, data || {});
}

/**
 * 积分订单详情
 * @returns {*}
 */
 export function IntegralOrderDetail(id) {
  return request.get("/integralorder/detail/" + id);
}

/**
 * 积分订单列表
 * @returns {*}
 */
 export function getIntegralOrderList(data) {
  return request.get("/integralorder/list", data);
}

/**
 * 积分订单统计数据
 * @returns {*}
 */
 export function getIntegralOrderData() {
  return request.get("/integralorder/data");
}

/**
 * 积分再次下单
 * @param string uni
 *
 */
 export function integralOrderAgain(uni) {
  return request.post("integralorder/again", { uni: uni });
}


/**
 * 取消积分订单
 * @returns {*}
 */
 export function cancelIntegralOrder(id) {
  return request.post("/integralorder/cancel", { id });
}

/**
 * 删除积分订单
 * @returns {*}
 */
 export function delIntegralOrder(uni) {
  return request.post("/integralorder/del", { uni });
}
/**
 * 积分确认收货
 * @returns {*}
 */
 export function takeIntegralOrder(uni) {
  return request.post("/integralorder/take", { uni });
}


/**
 * 积分订单查询物流信息
 * @returns {*}
 */
 export function integralExpress(uni) {
  return request.get("/integralorder/express/" + uni);
}
/**
 * 省代市代生成订单
 * 
 */
 export function conditionCreate(data) {
  return request.post("/conditioncreate" , data);
}
/**
 * 代理续费生成订单
 * 
 */
 export function renewCreate(data) {
  return request.post("renew/create" , data);
}
/**
 * 立即付款
 * @returns {*}
 */
 export function payIntegralOrder(uni, paytype, from) {
  return request.post("integralorder/pay", { uni, paytype, from });
}

/**
 * 积分退款理由
 * @returns {*}
 */
 export function getIntegralRefundReason() {
  return request.get("/integralorder/refund/reason");
}
/**
 * 提交积分退款
 * @returns {*}
 */
 export function postIntegralOrderRefund(data) {
  return request.post("/integralorder/refund/verify", data);
}
/**
 * 填写退货物流
 * @returns {*}
 */
 export function postOrderRefundExpressinfo(data) {
  return request.post("/order/refund/expressinfo", data);
}
/**
 * 选择服务类型
 * 
 */
 export function getAftersaleList(uni) {
  return request.get("/order/aftersale/list/" + uni);
}
/**
 * 申请售后
 * @returns {*}
 */
 export function postOrderRefundService(data) {
  return request.post("/order/refund/service", data);
}

/**
 * 获取售后地址
 * 
 */
 export function getShippingAddress(id) {
  return request.get("/order/refund/shippingaddress/" + id);
}